<template>
  <div class="p-6">
    <v-toolbar class="page-title" elevation="0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="mr-3" @click="goHome()" v-on="on" tile small>
            <v-icon left>fa fa-chevron-left</v-icon>
            Dashboard
          </v-btn>
        </template>
        <span> Go back </span>
      </v-tooltip>
      <v-btn
        @click="createBookDialog = true"
        small
        class="mr-4"
        color="primary"
      >
        <v-icon class="mr-1" dark>fa fa-plus</v-icon>
        Create New Book
      </v-btn>
      <slot name="actions"> </slot>
    </v-toolbar>
    <v-container>
      <div class="search-wrapper">
        <v-text-field
          v-model="search"
          label="Search..."
          prepend-inner-icon="fa fa-search"
          single-line
          outlined
          hide-details
          dense
        >
        </v-text-field>
        <small>
          Showing {{ searchResultsCount }} vegetables out of {{ books.length }}.
        </small>
      </div>
      <v-data-table
        v-model="selectedBook"
        :headers="headers"
        :items="books"
        :search="search"
        item-key="name"
        class="elevation-1"
        @current-items="getFiltered"
      >
        <template v-slot:item.Actions="{ item }">
          <td>
            <v-icon small class="mr-2" @click="viewBook(item)">
              fa fa-eye
            </v-icon>
            <v-icon
              v-if="userIsAdmin == 'true'"
              small
              class="mr-2"
              @click="editBook(item)"
            >
              fa fa-clone
            </v-icon>
            <v-icon
              v-if="userIsAdmin == 'true'"
              color="red"
              small
              @click="deleteBook(item)"
            >
              fa fa-trash
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-container>

    <CreateModal
      @create-modal-visibility="changeModalVisibility()"
      v-if="createBookDialog"
      :create-dialog="createBookDialog"
      :modal-title="'Create New Book'"
    ></CreateModal>
    <CreateModal
      @create-modal-visibility="changeEditModalVisibility()"
      :title="bookTitle"
      :description="bookDescription"
      :id="id"
      v-if="editBookDialog"
      :create-dialog="editBookDialog"
      :modal-title="'Edit Book'"
    ></CreateModal>
    <v-snackbar v-model="snackbar" :timeout="5000">
      {{ "Sucessfully deleted! " }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as API from "./../../api";

const CreateModal = () => import("./CreateDialog");

export default {
  name: "Books",
  components: { CreateModal },
  methods: {
    getBooks() {
      this.$api
        .get(API.endpoints.books)
        .then((response) => {
          this.books = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            message: error,
            type: "danger",
          });
        });
    },

    viewBook(item) {
      this.$router.push({ path: "books/" + item.ID });
    },
    getFiltered(filtered) {
      this.searchResultsCount = filtered.length;
    },

    editBook(item) {
      this.bookTitle = item.Title;
      this.bookDescription = item.Description;
      this.id = item.ID;
      this.editBookDialog = !this.editBookDialog;
    },

    deleteBook(item) {
      this.$api
        .delete(API.endpoints.books + "/" + item.ID)
        .then(() => {
          this.snackbar = true;
        })
        .catch(() => {
          console.log("Error deleting");
        });
    },

    changeEditModalVisibility() {
      this.editBookDialog = !this.editBookDialog;
    },
    changeModalVisibility() {
      this.createBookDialog = !this.createBookDialog;
    },

    goHome() {
      this.$router.push("/");
    },
  },
  data() {
    return {
      userIsAdmin: localStorage.getItem("userIsAdmin"),
      selectedBook: "",
      search: "",
      createBookDialog: false,
      editBookDialog: false,
      bookTitle: "",
      bookDescription: "",
      headers: [
        { text: "Id", value: "ID", align: "center" },
        { text: "Title", value: "Title", align: "center" },
        { text: "Description", value: "Description", align: "center" },
        { text: "Page Count", value: "PageCount" },
        { text: "Actions", value: "Actions" },
      ],
      books: [],
      searchResultsCount: 0,
      snackbar: false,
    };
  },
  mounted() {
    this.getBooks();
  },
};
</script>

<style scoped>
.page-title {
  border-bottom: 1px solid rgba(219, 219, 219, 0.48);
  font-size: 15px;
}
</style>
